const roleNames = {
  admin: 'Administrador',
  doorman: 'Portaria',
  analyst: 'Analista',
  contractor: 'Empresa Contratada',
  superadmin: 'Superadministrador'
}

export default roleNames;
